import { useCallback, useContext, useEffect } from "react";

import CircularLoader from "../../../components/loading/circularLoader";
import { DashBoardContext } from "../contexts/DashBoardContext";
import { useDashBoardFinanceiroService } from "../contexts/DashBoardFinanceiroContext";
import { ChartContainer, LoadingContainer } from "../styles/DashBoard";
import HorizontalBarChart from "./BarChart/HorizontalBarChart";
import ERPPieChart from "./PieChart/PieChart";

const BillsToPayChart = () => {
  const { defaultIntervalPeriodLabel } = useContext(DashBoardContext);
  const {
    billsChartsInfo,
    isBillToPayRefetchLoading,
    isBillToPayLoading,
    billToPayRefetch,
  } = useDashBoardFinanceiroService();

  //TODO para o Gritti debugar dps
  const refresh = useCallback(async () => {
    setTimeout(async () => {
      await billToPayRefetch();
    }, 100);
  }, [billToPayRefetch]);

  useEffect(() => {
    refresh();
  }, [
    billsChartsInfo.billsToPayGroupPeriod,
    billsChartsInfo.companies,
    refresh,
  ]);

  const chartView = {
    bar: (
      <HorizontalBarChart
        label={
          defaultIntervalPeriodLabel[
            billsChartsInfo?.billsToPayGroupPeriod || "date"
          ].strInfo
        }
        closedLabel={"Pago"}
        groupedDate={billsChartsInfo.billsToPayGroupPeriod}
        data={billsChartsInfo.billsToPayData}
      />
    ),
    pie: (
      <ERPPieChart
        closedLabel={"Pago"}
        data={billsChartsInfo.billsToPayPieChartData}
      />
    ),
  };

  if (isBillToPayRefetchLoading || isBillToPayLoading)
    return (
      <LoadingContainer>
        <CircularLoader />
      </LoadingContainer>
    );

  return (
    <ChartContainer>
      {chartView[billsChartsInfo.billsToPayChartView]}
    </ChartContainer>
  );
};

export default BillsToPayChart;
